import React from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
// css
import '../../../styles/commonStyles.css';

class ContattiCliente extends React.Component {  
  constructor(props) {
    super(props);

    const { editMode, panCliente } = this.props;

    this.state = {
      editMode,
      telefono: (editMode)? panCliente['telefono'] : '',
      cellulare: (editMode)? panCliente['cellulare'] : '',
      email: (editMode)? panCliente['email'] : '',
      noteContatti: (editMode)? panCliente['noteContatti'] : '',      
    }

    this.handleContact = this.handleContact.bind(this);
  }

  render() {       
    const { telefono, cellulare, email, noteContatti } = this.state;
    // Quando il campo nrRate di PANEL_PAGAMENTO è superiore a zero
    // needsTwoContacts diventa true e aggiorna required di telefono ed email
    // Se si tratta di contratta a rate, è necessario un 2° contatto (dopo il cellulare)
    const { needsTwoContacts } = this.props;
    
  	return (    
      <React.Fragment>  
  		<Row className="noNegativeMargin">
       	<Col xs={12} lg={3}>		        	
	          <label htmlFor="telefono">Telefono</label>             
            <FormControl id="telefono" name="telefono" type="text"             
              required={(needsTwoContacts && (email == '' || cellulare == '')) || cellulare == ''} 
              onChange={this.handleContact} 
              data-caption="Telefono" autoComplete="off"
              defaultValue={telefono} />        		 	          	      
        </Col>	

        <Col xs={12} lg={3}>		        	
	          <label htmlFor="cellulare">Cellulare</label>
	          <FormControl 
	            id="cellulare" name="cellulare"  			                      
	   					type="text" 
              required={(needsTwoContacts && (email == '' || telefono == '')) || telefono == ''}  
              data-caption="Cellulare" onChange={this.handleContact} 
              autoComplete="off" defaultValue={cellulare}
        		/> 	          	
        </Col>	

        <Col xs={12} lg={4}>		        	
	          <label htmlFor="email">Email</label>
            <FormControl id="email" name="email" type="email" 
              required
              // required={needsTwoContacts && (telefono == '' || cellulare == '')} 
              onChange={this.handleContact} 
              data-caption="Email" data-parse="Email" autoComplete="off"
              defaultValue={email}/> 
        </Col>		     		                
      </Row>  
      <Row className="noNegativeMargin mt-sm-1 mb-sm-1">
      <Col xs={12}>             
          <label htmlFor="noteContatti">Note aggiuntive</label>
          <FormControl 
            id="noteContatti" name="noteContatti"            
            type="text" maxLength="255" 
            data-caption="Note aggiuntive (contatti)"
            autoComplete="off"
            defaultValue={noteContatti}              
          />                              
      </Col>
    </Row>
    </React.Fragment>    
  	);
  }

  handleContact(e) {
    const field = e.target;  

    this.setState({
      [field.name]: [field.value]
    });
  }
}

export default ContattiCliente;


// WEBPACK FOOTER //
// ./src/cmp/Orders/Panels/PanelCliente/ContattiCliente.js